import { render, staticRenderFns } from "./AddEventDocument.vue?vue&type=template&id=70f0e5bd&scoped=true"
import script from "./AddEventDocument.vue?vue&type=script&lang=js"
export * from "./AddEventDocument.vue?vue&type=script&lang=js"
import style0 from "./AddEventDocument.vue?vue&type=style&index=0&id=70f0e5bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f0e5bd",
  null
  
)

export default component.exports